"use client"; 

import { useState } from "react";
import { useForm } from "react-hook-form";
import { toast } from 'react-toastify'
import axios from "axios";


import { classNames } from "../../../../../lib/helpers";
import { rgx } from "../../../../../lib/helpers";

export default function ContactForm({ }) {

  const FORM_FIELDS = [
    { element: 'input', field: 'name', name: "Full Name", register: { required: "Your Name is required", maxLength: { value: 50, message: "This is too long." }} }, 
    { element: 'input', field: 'email', name: "Email", register: { required: "Email is required", pattern: {value: rgx.email, message: "Email should be valid"} } }, 
    { element: 'input', field: 'phone', name: "Phone" }, 
    { element: 'textarea', rows: 4, field: 'message', name: "Message", register: { required: "Your Message is required", maxLength: { value: 2000, message: "This is too long." }} }, 
  ]

  const { register, handleSubmit, formState, reset, control } = useForm({ mode: 'onChange', reValidateMode: 'onChange', }); 
  const { errors } = formState;

  const [isFormLoading, setIsFormLoading] = useState(false);  // To disable Button while loading  
  const formURL = '/api/services/contactform'
  const formMethod = 'post' 

  const onSubmit = data => {
    setIsFormLoading(true);

    axios({
      method: formMethod,
      url: formURL,
      data: data,
    }).then(response => {
        setIsFormLoading(false);
        reset();
        toast.success("Thank you for contacting us!");
      }).catch((error) => {
        setIsFormLoading(false);      
        toast.error("Sorry, something went wrong!");
      });
  }


  return (
    <>
      <form 
        method="POST" 
        className="grid grid-cols-1 gap-y-6"
        onSubmit={handleSubmit(onSubmit)}
      >
        {FORM_FIELDS?.map((item, index) => (
          <div key={index}>
            <label htmlFor={item?.field} className="sr-only">
              {item?.name}
            </label>
            <item.element {...register(item.field, { ...item?.register } )}
              type="text"
              name={item?.field}
              rows={item?.rows}
              // autoComplete="name"
              // className="block w-full rounded-md border-gray-300 py-3 px-4 placeholder-gray-500 shadow-sm focus:border-crisp-500 focus:ring-crisp-500"
              className={classNames(errors[item.field] ? 
                'border-red-300 focus:ring-red-500 focus:border-red-500' : 
                'border-gray-300 focus:ring-crisp-500 focus:border-crisp-500', 
                'shadow-sm block w-full sm:text-base rounded-md py-3 px-4 placeholder-gray-500 ')}
              placeholder={item?.name}
            />
            
            {errors[item.field] && <p className="ml-0.5 mt-0.5 text-xs text-red-500">{errors[item.field].message}</p>}

          </div>
        ))}
        

        <div>
          <button
            type="submit"
            disabled={isFormLoading}
            className={classNames(isFormLoading ? 'animate-pulse' : '', 'inline-flex justify-center rounded-md border border-transparent bg-crisp-600 py-3 px-6 text-base font-medium text-white shadow-sm hover:bg-crisp-700 focus:outline-none focus:ring-2 focus:ring-crisp-500 focus:ring-offset-2')}
          >
            Submit          
          </button>
        </div>
        <p className="text-xs text-gray-500">          
          {`By clicking "Submit," you agree that your data will be handled in accordance with`}
          {` `}
          
          <a href="/privacy" className="text-crisp-600 hover:text-crisp-500">
            {`Stackreaction’s Privacy Policy`}            
          </a>
          
          {` `}
          {`, and you authorize Stackreaction to send you updates. `}
          
        </p>
      </form>
    </>
  )
}